import {getHost} from '@albert-io/environment';

import {getRequestAgent} from './requestAgent';

/**
 * The signed-in user behind the cookie, or a 401.
 * Kept apart from `index.js` so transports can import it without the session bootstrap.
 */
export function getSessionDetails() {
  return getRequestAgent().get(`${getHost()}/auth/session`);
}
